import React from "react";
import PlatformAnalyticsExperience from "./PlatformAnalyticsExperience";

/*
 * Google Analytics (GA4) — served by the shared Platform Analytics experience.
 *
 * This file configures the canonical workspace; it does not own a copy of it.
 * There is no GA4 shell, no GA4 stylesheet and no GA4 layout: the composition,
 * EDEN placement, control geometry, KPI primitives and responsive bands are
 * the same ones every other Analytics page renders. That is deliberate — the
 * earlier CTV/Display migration reproduced the visual tokens without the
 * composition, and the page read as disconnected panels on a background.
 *
 * What differs is the reporting SOURCE, declared by the profile as
 * sourceType: "measurement" / metricsSource: "ga4":
 *   - the payload comes from the GA4 contract, not the paid-media topline;
 *   - the KPI vocabulary is GA4-native (users, sessions, engagement);
 *   - spend, CTR/CPC/CPM/CPA, basis and pacing are absent, because GA4 does
 *     not report media cost and implying otherwise would be a lie;
 *   - Creative Performance is absent, because GA4 traffics no creatives.
 *
 * Distinct from /google-analytics, which serves PAID Google Search. The two
 * are different reporting products; the route names have long conflated them.
 */
export default function Ga4Analytics() {
  return <PlatformAnalyticsExperience platformKey="ga4" />;
}
